import { z } from "zod";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import type { ModuleProps } from "../types";

export const qualityGradingConfig = z.object({
  grades: z.array(z.string()).default(["A", "B", "C"]),
});
export type QualityGradingConfig = z.infer<typeof qualityGradingConfig>;

export function QualityGradingModule({ config, state, onBack, onComplete }: ModuleProps<QualityGradingConfig, { grade?: string }>) {
  const grades = config.grades?.length ? config.grades : ["A", "B", "C"];
  const current = state?.grade;
  return (
    <Card className="p-6 space-y-4">
      <h2 className="text-xl font-semibold">Quality Grading</h2>
      <div className="flex gap-2 flex-wrap">
        {grades.map((g) => (
          <Button
            key={g}
            variant={current === g ? "default" : "outline"}
            onClick={() => onComplete({ grade: g })}
          >
            Grade {g}
          </Button>
        ))}
      </div>
      <div className="flex justify-between">
        <Button variant="outline" onClick={onBack}>Back</Button>
        {current && <Button onClick={() => onComplete({ grade: current })}>Continue</Button>}
      </div>
    </Card>
  );
}
